// frontend/src/AppProvider.js
import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { AnalysisProvider } from './contexts/AnalysisContext';
import { HistoryProvider } from './contexts/HistoryContext';
import { ChatProvider } from './contexts/ChatContext';
import { UIProvider } from './contexts/UIContext';

// This component nests all the individual context providers in the correct order.
// HistoryProvider is nested inside AuthProvider so it can access auth state.
const AppProvider = ({ children }) => {
    return (
        <AuthProvider>
            <HistoryProvider>
                <AnalysisProvider>
                    <ChatProvider>
                        <UIProvider>
                            {children}
                        </UIProvider>
                    </ChatProvider>
                </AnalysisProvider>
            </HistoryProvider>
        </AuthProvider>
    );
};

export default AppProvider;